export default __webpack_public_path__ + "static/media/ontario.a76e1f08.png";